import { ReactNode } from "react";
import { useBlockedIpCheck } from "@/hooks/useBlockedIpCheck";
import BlockedPage from "@/pages/BlockedPage";
import { Loader2 } from "lucide-react";

interface IpBlockGuardProps {
  children: ReactNode;
}

const IpBlockGuard = ({ children }: IpBlockGuardProps) => {
  const { isBlocked, isChecking } = useBlockedIpCheck();

  // Show loading while checking
  if (isChecking) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  // Show blocked page if IP is blocked
  if (isBlocked) {
    return <BlockedPage />;
  }

  // Otherwise render children normally
  return <>{children}</>;
};

export default IpBlockGuard;
